// extracted by mini-css-extract-plugin
module.exports = {"sign-loading-icon":"_13jBu5Cr82TGu3yKvRj8Sn","sign-component":"_6NUbrVPRl6shOUWDFH5us"};